import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { outlineService } from './outline.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService,
    private router: Router,
    private outlineService: outlineService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/inicio-sesion']);
      return of(false);
    }

    // Obtener id_modulo e id_vista desde los datos de la ruta
    const id_modulo = route.data['id_modulo'];
    const id_vista = route.data['id_vista'];

    // Obteniendo el ID del perfil del usuario desde AuthService
    const perfilId = this.authService.getCurrentUser()?.idPerfil;
    //const perfilId = 1;


    // Cargar los permisos con el perfilId obtenido
    return this.outlineService.cargarPermisos(perfilId).pipe(
      map(() => {
        // Verificar ambos permisos: "Bloquear" y "Ocultar"
        const tienePermisoBloquear = this.outlineService.tienePermiso(id_modulo, id_vista, 'Bloquear');
        const tienePermisoOcultar = this.outlineService.tienePermiso(id_modulo, id_vista, 'Ocultar');

        // Si tiene cualquiera de los permisos, denegar acceso
        if (!tienePermisoBloquear || !tienePermisoOcultar) {
          Swal.fire({
            title: 'Acceso denegado',
            text: 'No tienes permisos para acceder a esta vista',
            imageUrl: 'assets/img/icons/logos/bloquear1.png',
            imageWidth: 100,
            imageHeight: 100,
            imageAlt: 'Icono de candado',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });

          return false;
        }

       // Cargar elementos relacionados con el id_modulo e id_vista
       this.outlineService.cargarElementos(perfilId).subscribe((response) => {
        if (response.success) {
          // Aplicar acciones según los permisos en los elementos obtenidos
          response.data.forEach((element: any) => {
            const accion = this.outlineService.aplicarAccion(id_modulo, id_vista, element.id_elemento);
            // Aquí puedes agregar más lógica para modificar los elementos en el DOM o componente
          });
        } else {
          console.warn('No se encontraron elementos restringidos para este perfil.');
        }
      });

        // Si no tiene los permisos de "Bloquear" ni "Ocultar", permitir el acceso
        return true;

      })
    );
  }
}
